import request from '../request';
import * as cartStorage from './cartStorage';

function deriveFromCart(form) {
  if (!Array.isArray(form)) return { code: '', hasDiscount: false };
  for (const item of form) {
    if (item.type === 'promoCode' && item.keyword) {
      return { code: item.keyword, hasDiscount: true };
    }
    if (item.keyword) {
      return { code: item.keyword, hasDiscount: true };
    }
    const nested = [item.subtickets, item.tickets, item.tours];
    for (const arr of nested) {
      if (!Array.isArray(arr)) continue;
      for (const sub of arr) {
        if (sub && sub.keyword) {
          return { code: sub.keyword, hasDiscount: true };
        }
      }
    }
  }
  return { code: '', hasDiscount: false };
}

const initial = deriveFromCart(cartStorage.load());

export function syncPromoCodesWithCart(store) {
  store.subscribe((mutation, state) => {
    if (typeof mutation.type === 'string' && mutation.type.startsWith('cart/')) {
      store.commit('promoCodes/syncFromCart', state.cart.form);
    }
  });
}

export default {
  namespaced: true,
  state: {
    loading: false,
    hasDiscount: initial.hasDiscount,
    form: { code: initial.code },
    data: {},
    errors: {},
  },
  mutations: {
    setCode(state, code) {
      state.form.code = code;
    },
    setHasDiscount(state, v) {
      state.hasDiscount = v;
    },
    syncFromCart(state, form) {
      const derived = deriveFromCart(form);
      state.form.code = derived.code;
      state.hasDiscount = derived.hasDiscount;
    },
  },
  actions: {
    setCode(context, v) {
      return new Promise((resolve) => {
        context.commit('setCode', v);
        resolve();
      });
    },
    validate(context) {
      return new Promise((resolve, reject) => {
        const url = context.rootState.app.endpoints.PROMOCODE_VALIDATE;
        const { app } = context.rootState;
        const data = {
          keyword: context.state.form.code,
          sum: context.rootGetters['cart/total'],
        };
        context.dispatch('cart/setPromoCodeDoesNotApplyToCurrentItems', null, {
          root: true,
        });
        request.make(
          {
            type: 'GET',
            url: `${app.API_URL}${context.rootState.language}/${url}`,
            data,
          },
          (err, res) => {
            context.dispatch('cart/setPromoCodeDoesNotApplyToCurrentItems', true, {
              root: true,
            });
            if (err === null && res.statusCode === 200) {
              //context.commit('setData', res.data);
              const items = res.body.data.items;
              const discount = res.body.data.discount;
              const itemsCount = res.body.data.itemsCount;
              const useCountPrice =
                discount.use_count_price === '1' &&
                itemsCount &&
                Object.keys(itemsCount).length > 0;
              if (Array.isArray(items) && useCountPrice) {
                context.commit('setHasDiscount', true);
                context.dispatch(
                  'cart/applyCountLimitedPromoCode',
                  { items, itemsCount, discount },
                  { root: true }
                );
                resolve();
              } else if (Array.isArray(items)) {
                // apply to Items
                context.rootState.cart.form.forEach((cartItem, index) => {
                  context.commit('setHasDiscount', true);
                  if (items.includes(cartItem.id.toString())) {
                    context.dispatch(
                      'cart/applyPromoCode',
                      {
                        cartItemIndex: index,
                        discountId: discount.id,
                        units: discount.units,
                        amount: discount.amount,
                        keyword: discount.keyword,
                      },
                      { root: true }
                    );
                  }
                  if (typeof cartItem.subtickets !== 'undefined') {
                    cartItem.subtickets.forEach((subticket, subticketIndex) => {
                      if (items.includes(subticket.id)) {
                        context.dispatch(
                          'cart/applyPromoCodeToSubticket',
                          {
                            cartItemIndex: index,
                            subticketIndex: subticketIndex,
                            discountId: discount.id,
                            units: discount.units,
                            amount: discount.amount,
                            keyword: discount.keyword,
                          },
                          { root: true }
                        );
                      }
                    });
                    context.dispatch(
                      'cart/recalculateTicketTotal',
                      { cartItemIndex: index },
                      { root: true }
                    );
                  }
                  if (typeof cartItem.tickets !== 'undefined') {
                    let anyTicketDiscounted = false;
                    cartItem.tickets.forEach((ticket, ticketIndex) => {
                      if (items.includes(ticket.id.toString())) {
                        anyTicketDiscounted = true;
                        context.dispatch(
                          'cart/applyPromoCodeToTicket',
                          {
                            cartItemIndex: index,
                            ticketIndex: ticketIndex,
                            discountId: discount.id,
                            units: discount.units,
                            amount: discount.amount,
                            keyword: discount.keyword,
                          },
                          { root: true }
                        );
                      }
                    });
                    context.dispatch(
                      'cart/recalculateTicketTotal',
                      { cartItemIndex: index },
                      { root: true }
                    );
                    if (anyTicketDiscounted && !items.includes(cartItem.id.toString())) {
                      context.dispatch(
                        'cart/setCartItemKeyword',
                        { cartItemIndex: index, keyword: discount.keyword },
                        { root: true }
                      );
                    }
                  }
                  if (typeof cartItem.tours !== 'undefined') {
                    let anyTourDiscounted = false;
                    cartItem.tours.forEach((tour, tourIndex) => {
                      if (items.includes(tour.id.toString())) {
                        anyTourDiscounted = true;
                        context.dispatch(
                          'cart/applyPromoCodeToTour',
                          {
                            cartItemIndex: index,
                            tourIndex: tourIndex,
                            discountId: discount.id,
                            units: discount.units,
                            amount: discount.amount,
                            keyword: discount.keyword,
                          },
                          { root: true }
                        );
                      }
                    });
                    context.dispatch(
                      'cart/recalculateTicketTotal',
                      { cartItemIndex: index },
                      { root: true }
                    );
                    if (anyTourDiscounted && !items.includes(cartItem.id.toString())) {
                      context.dispatch(
                        'cart/setCartItemKeyword',
                        { cartItemIndex: index, keyword: discount.keyword },
                        { root: true }
                      );
                    }
                  }
                });
                resolve();
              } else if (items === 'cart') {
                context.commit('setHasDiscount', true);
                let totalPrice = parseInt(discount.amount) * -1;
                if (parseInt(discount.units, 10) === 0) {
                  totalPrice = parseInt(discount.amount);
                }
                const cartItem = {
                  type: 'promoCode',
                  count: 1,
                  units: discount.units,
                  amount: totalPrice,
                  totalPrice: totalPrice,
                  id: discount.id,
                  keyword: discount.keyword,
                };
                context.dispatch('cart/add', cartItem, { root: true });
                resolve(cartItem);
              } else {
                reject();
              }
            }
          }
        );
      });
    },
    setHasDiscount(context, v) {
      context.commit('setHasDiscount', v);
    },
    remove(context) {
      context.commit('cart/removePromocode', null, { root: true });
      context.commit('setHasDiscount', false);
      context.commit('setCode', '');
    },
  },
};
